// ----------------------------------------------------------------------
// <copyright file="Izenda.TileTitleFrontSide.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');
  var observer = require('mobx-react').observer;
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var TileTitleFrontSide = React.createClass({
    propTypes: {
      dashboardPart: React.PropTypes.object.isRequired
    },

    publishFinishedRender: function () {
      var props = this.props;

      props.printingMode
        && props.finishedRender
        && props.fulfilledData
        // Work around for fontWeight is bold.
        // when bold fontWeight, it takes more time to display.
        && setTimeout(function () {
          props.finishedRender();
        }, 20);
    },

    componentDidMount: function () {
      this.publishFinishedRender();
    },

    componentDidUpdate: function () {
      this.publishFinishedRender();
    },

    render: function () {
      var props = this.props;
      var dashboardPart = props.dashboardPart;
      var title = getStyle('contentTitle');
      var description = getStyle('contentDescription');
      var contentTitle = getText('contentTitle');
      var contentDescription = getText('contentDescription');

      return (
        <GridLayout className="u_paddingBottom">
          {contentTitle &&
            <GridLayout.Row>
              <GridLayout.Col style={title.gridStyle}>
                <span title={contentTitle} style={title.spanStyle}>{contentTitle}</span>
              </GridLayout.Col>
            </GridLayout.Row>
          }
          {contentDescription &&
            <GridLayout.Row>
              <GridLayout.Col style={description.gridStyle}>
                <span title={contentDescription} style={description.spanStyle}>{contentDescription}</span>
              </GridLayout.Col>
            </GridLayout.Row>
          }
        </GridLayout>
      );

      /**
       * Get font style to use it inline style
       * @param {string} key
       * @returns {}
       */
      function getStyle(key) {

        var settings = dashboardPart[key] && dashboardPart[key].settings;

        var style = {
          fontFamily: settings.fontFamily,
          fontSize: settings.fontSize + 'px',
          fontWeight: settings.fontBold ? 'bold' : 'normal',
          textAlign: settings.alignment || 'none',
          textDecoration: settings.fontUnderline ? 'underline' : 'none',
          fontStyle: settings.fontItalic ? 'italic' : 'normal',
          color: settings.fontColor
        };

        var backgroundColor = {
          backgroundColor: settings.fontHighlightColor
        };

        return {
          gridStyle: style,
          spanStyle: backgroundColor
        }
      }

      function getText(key) {
        return dashboardPart[key] && dashboardPart[key].text;
      }
    }
  });

  module.exports = observer(TileTitleFrontSide);

} ());



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Izenda.TileTitleFrontSide.jsx